import { TypeOf, yup } from '@guiker/shared-framework'

export const setEarlyTerminationSchema = yup.object({
  terminatesAt: yup.string().required(),
})

export type SetEarlyTerminationSchema = TypeOf<typeof setEarlyTerminationSchema>
